mutation sendAnalytics($event: String!, $data: JSON!) {
    sendAnalytics(event: $event, data: $data)
}
